import { useGetCart } from '@/hooks/cart/useGetCart';
import { ShoppingCartOutlined } from '@ant-design/icons';
import { Badge } from 'antd';
import { useNavigate } from 'react-router-dom';

type Props = {
  marketId?: string;
};

const MarketShoppingCartIcon = ({ marketId }: Props) => {
  const navigate = useNavigate();
  const { data: cart, isLoading, isError } = useGetCart(marketId);

  if (isError || !marketId || !cart || isLoading) {
    return (
      <ShoppingCartOutlined
        className="text-xl cursor-pointer"
        onClick={() => navigate(`/market/${marketId}/cart`)}
      />
    );
  }

  return (
    <Badge count={cart.lineItems.length}>
      <ShoppingCartOutlined
        className="text-xl cursor-pointer"
        onClick={() => navigate(`/market/${marketId}/cart`)}
      />
    </Badge>
  );
};

export default MarketShoppingCartIcon;
